var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101.855,
    height: 120.882,
    viewBox: "0 0 89.855 120.882",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.201,
    x2: 2.01,
    y2: 1.327,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55a4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55a4ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Union_42",
    x: 0,
    y: 0,
    width: 101.855,
    height: 120.882,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#07111a"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Union_42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_42-2",
    "data-name": "Union 42",
    d: "M19018.258-10914.118a3.8,3.8,0,0,1-3.164-1.7l-2.035-3.054a3.8,3.8,0,0,1-.637-2.107l0-4.56h19.021l-.006,4.56a3.849,3.849,0,0,1-.635,2.107l-2.031,3.054a3.81,3.81,0,0,1-3.17,1.7Zm-5.859-15.222a.478.478,0,0,0-.01-.091,34.164,34.164,0,0,0-6.207-10.877,20.786,20.786,0,0,1-5.182-13.765,20.841,20.841,0,0,1,20.861-20.928,20.929,20.929,0,0,1,20.994,20.928,20.814,20.814,0,0,1-5.18,13.765,34.166,34.166,0,0,0-6.209,10.877c0,.033-.01.063-.014.091Z",
    transform: "translate(-18976 11000)",
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.76eb37dc591723580a1b487fb219446c.svg";
export { ForwardRef as ReactComponent };